import { FilterMatchMode } from "primereact/api"

export class Usuarios {
    model = {
        id: { value: null, export: false, table: false },
        login: {
            value: '', export: true, header: 'Logín', required: 'Nombre de usuario es requerido', maxLength: 'Máximo 200 caracteres',
            minLength: 'Mínimo 4 caracteres', max: 400, min: 4, filterField: 'login', table: true, filter: true, sort: true,
            filterPlaceholder: 'Buscar por logín', matchMode: FilterMatchMode.CONTAINS
        },
        empresa: {
            value: null, export: false, header: 'Empresa', required: 'Empresa es requerido',
            filterField: 'empresa', table: true, filter: true, sort: true, filterPlaceholder: 'Buscar por Empresa', matchMode: FilterMatchMode.CONTAINS
        },
        identificacion: {
            value: '', export: true, header: 'Identificación', required: 'Identificación es requerido', maxLength: 'Máximo 200 caracteres',
            minLength: 'Mínimo 4 caracteres', max: 400, min: 4, filterField: 'identificacion', table: true, filter: true, sort: true,
            filterPlaceholder: 'Buscar por identificacion', matchMode: FilterMatchMode.CONTAINS
        },
        nombre: {
            value: '', export: true, header: 'Nombres completos', required: 'Nombre es requerido', maxLength: 'Máximo 300 caracteres',
            minLength: 'Mínimo 4 caracteres', max: 400, min: 4, filterField: 'nombre', table: true, filter: true, sort: true,
            filterPlaceholder: 'Buscar por nombres', matchMode: FilterMatchMode.CONTAINS
        },
        email: {
            value: '', export: true, header: 'Correo electrónico', required: 'Email es requerido', maxLength: 'Máximo 300 caracteres',
            minLength: 'Mínimo 4 caracteres', max: 300, min: 4, filterField: 'email', table: true, filter: true, sort: true
        },
        estado: { header: 'Habilitado', value: true, required: 'Estado es requerido', optionLabel: 'nombre', export: true, table: true },
        google_2fa_enabled: { header: 'Habilitar Doble Autenticación', value: false, export: true, table: false },
        firma_digital_activa: { header: 'Habilitar Firma Electrónica', value: false, export: true, table: false },
        enviar: { header: 'Enviar correo', value: { nombre: 'NO', cat_id: false }, required: 'Campo requerido', optionLabel: 'nombre', export: false, table: false },
        tipo_negocio: { header: 'Áreas de negocio', value: [], required: 'Seleccione una opción', optionLabel: 'nombre', export: false, table: false },
    }
    optionLabel = 'nombre'

    static getReportTemplate(data, info) {
        const COLORS = {
            headerBg: '#f8fafc',
            zebraBg: '#f1f5f9',
            border: '#e2e8f0',
            textMain: '#1e293b',
            textLight: '#64748b',
            primary: '#0f172a',
            success: '#16a34a',
            danger: '#dc2626',
            warning: '#f59e0b'
        };

        const buildTableBody = (records) => {
            const body = [];
            // Header de la tabla
            body.push([
                { text: 'ID', style: 'tableHeader' },
                { text: 'IDENTIFICACIÓN', style: 'tableHeader' },
                { text: 'NOMBRE USUARIO', style: 'tableHeader' },
                { text: 'LOGIN', style: 'tableHeader' },
                { text: 'EMAIL', style: 'tableHeader' },
                { text: 'EMPRESA PRINCIPAL', style: 'tableHeader' },
                { text: 'ESTADO', style: 'tableHeader' },
                { text: '2FA', style: 'tableHeader' }
            ]);

            records.forEach((row, index) => {
                const isZebra = index % 2 === 1;
                const fill = isZebra ? COLORS.zebraBg : null;
                body.push([
                    { text: row.id || '-', style: 'cellText', fillColor: fill, alignment: 'center' },
                    { text: row.identificacion || '-', style: 'cellText', fillColor: fill },
                    { text: row.nombre_usuario || '-', style: 'cellBold', fillColor: fill },
                    { text: row.login || '-', style: 'cellText', fillColor: fill },
                    { text: row.email || '-', style: 'cellText', fillColor: fill, fontSize: 7.5 },
                    { text: row.empresa_principal || '-', style: 'cellText', fillColor: fill },
                    { text: row.habilitado || 'INACTIVO', style: 'cellStatus', color: row.habilitado === 'ACTIVO' ? COLORS.success : COLORS.danger, fillColor: fill, bold: true, alignment: 'center' },
                    { text: row.doble_factor || 'NO', style: 'cellText', fillColor: fill, alignment: 'center' }
                ]);
            });

            return body;
        };

        // Definición del documento
        return {
            pageSize: 'A4',
            pageOrientation: 'landscape',
            pageMargins: [20, 20, 20, 40],

            footer: (currentPage, pageCount) => ({
                columns: [
                    {
                        text: `Usuario: ${info.usuario_generador}`,
                        style: 'footerText',
                        width: '30%'
                    },
                    {
                        text: `Total registros: ${info.total_usuarios}`,
                        style: 'footerText',
                        alignment: 'center',
                        width: '*'
                    },
                    {
                        text: `Página ${currentPage} de ${pageCount}`,
                        alignment: 'right',
                        style: 'footerText',
                        width: '30%'
                    }
                ],
                margin: [20, 10, 20, 0]
            }),

            content: [
                {
                    margin: [0, 0, 0, 12],
                    columns: [
                        {
                            width: '*',
                            columns: [
                                {
                                    width: 'auto',
                                    stack: info.logo ? [
                                        {
                                            image: info.logo,
                                            width: 60,
                                            margin: [0, 0, 10, 0]
                                        }
                                    ] : []
                                },
                                {
                                    width: '*',
                                    text: info.razon_social || 'Sistema',
                                    style: 'brand',
                                    margin: [0, 15, 0, 0]
                                }
                            ]
                        },
                        {
                            width: 'auto',
                            stack: [
                                {
                                    text: 'REPORTE GENERAL DE USUARIOS',
                                    style: 'reportTitle'
                                },
                                {
                                    text: `Generado el: ${info.fecha_generacion || new Date().toLocaleString()}`,
                                    style: 'reportMeta'
                                },
                                {
                                    text: `Empresa: ${info.razon_social || 'Todas'}`,
                                    style: 'reportMeta'
                                }
                            ],
                            alignment: 'right'
                        }
                    ]
                },

                {
                    table: {
                        headerRows: 1,
                        // Ajuste de anchos para 10 columnas
                        widths: ['5%', '12%', '18%', '10%', '20%', '20%', '10%', '5%'],
                        body: buildTableBody(data)
                    },
                    layout: {
                        hLineWidth: (i, node) => (i === 0 || i === 1 || i === node.table.body.length) ? 1 : 0.5,
                        vLineWidth: () => 0,
                        hLineColor: (i) => (i === 1) ? COLORS.primary : COLORS.border,
                        paddingLeft: (i) => 4,
                        paddingRight: (i) => 4,
                        paddingTop: (i) => 6,
                        paddingBottom: (i) => 6
                    }
                }
            ],

            styles: {
                brand: { fontSize: 11, bold: true, color: COLORS.textLight },
                reportTitle: { fontSize: 14, bold: true, color: COLORS.primary, margin: [0, 0, 0, 2], font: 'Roboto' },
                reportMeta: { fontSize: 8, color: COLORS.textLight },
                tableHeader: { fontSize: 8, bold: true, color: COLORS.textLight, fillColor: COLORS.headerBg, margin: [0, 4, 0, 4], alignment: 'center' },
                // Estilos de celda
                cellText: { fontSize: 8.5, color: COLORS.textMain },
                cellBold: { fontSize: 8.5, bold: true, color: COLORS.textMain },
                cellSub: { fontSize: 7.5, color: COLORS.textLight },
                cellStatus: { fontSize: 8, bold: true },
                footerText: { fontSize: 8, color: COLORS.textLight }
            },
            defaultStyle: { font: 'Roboto' }
        };
    }
}
